<template>
  <BForm @submit.prevent>
    <BRow>
      <BCol md="12">
        <BaseInput
          v-model="localCompanyName"
          label="企業名"
          type="text"
          placeholder="例: 株式会社〇〇清掃"
          :maxlength="50"
          :required="true"
          :error-message="errors.companyName"
        />
      </BCol>
    </BRow>

    <BRow class="mt-3">
      <BCol md="12">
        <BFormGroup label="企業色" label-class="form-label">
          <div class="color-display-container">
            <div class="color-preview-wrapper">
              <div
                class="color-preview"
                :style="{ backgroundColor: assignedColor }"
              ></div>
              <span class="color-name">{{ assignedColorName }}</span>
            </div>
            <div class="color-info">
              <i class="bi bi-info-circle me-1"></i>
              企業の登録順により自動的に色が決定されます
            </div>
          </div>
        </BFormGroup>
      </BCol>
    </BRow>

    <div class="text-muted small">
      <i class="bi bi-info-circle me-1"></i>
      * の項目は必須入力です。
    </div>
  </BForm>
</template>

<script setup>
import { ref, computed, watch } from 'vue'
import { BForm, BRow, BCol, BFormGroup } from 'bootstrap-vue-next'
import BaseInput from '@/components/atoms/BaseInput.vue'
import { calculateCompanyColor } from '@/services/systemSettings/collectionCompanyService.js'

const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  },
  errors: {
    type: Object,
    default: () => ({})
  },
  companyOrder: {
    type: Number,
    required: true
  }
})

const emit = defineEmits(['update:modelValue'])



// ローカルstate（BaseInputはv-modelで繋ぎ、カーソルリセットを防ぐ）
const localCompanyName = ref(props.modelValue.companyName ?? '')

// 親からmodelValueが変わったときにローカルを同期
watch(() => props.modelValue.companyName, (newVal) => {
  if (newVal !== localCompanyName.value) {
    localCompanyName.value = newVal ?? ''
  }
})

// ローカルの変更を親に伝える
watch(localCompanyName, (newVal) => {
  emit('update:modelValue', { ...props.modelValue, companyName: newVal })
})

// 企業の順番に基づいて色を決定
const assignedColor = computed(() => calculateCompanyColor(props.companyOrder).color)
const assignedColorName = computed(() => calculateCompanyColor(props.companyOrder).name)
</script>

<style scoped>
.color-display-container {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.color-preview-wrapper {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.color-preview {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 2px solid #dee2e6;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.color-name {
  font-weight: 500;
  color: #495057;
}

.color-info {
  font-size: 0.875rem;
  color: #6c757d;
}

.form-label {
  font-weight: 500;
  color: #495057;
  margin-bottom: 0.5rem;
}
</style>
